export const downloadFileInBase64 = (base64: string, fileName: string, type: string) => {
  const lastDotIndex = fileName?.lastIndexOf('.'); //to get the extension in a case where there is a . character in the file name itself
  const newExtension = type;
  const newFilename = fileName?.substring(0, lastDotIndex) + '.' + newExtension;

  // Decode the base64 string
  const binaryString = atob(base64);
  const binaryLen = binaryString?.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString?.charCodeAt(i);
  }

  // Create a Blob from the byte array
  const blob = new Blob([bytes], { type });

  // Create a link element
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = newFilename;

  // Append the link to the document and trigger the download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}